<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.WarehousingInstructions')"
    width="500px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div>
      <el-form label-width="110px" label-position="left">
        <el-form-item label="">
          <div style="display: flex;align-items: center">
            <el-checkbox v-model="form.ownWarehouse" no="1">{{ $t('queryJob.GoodsIntoThisWarehouse') }}</el-checkbox>
            <el-checkbox v-model="form.takePhotos" no="2">{{ $t('queryJob.NeedPhotos') }}</el-checkbox>
            <el-checkbox v-model="form.documentsAttached" no="3">{{ $t('queryJob.AttachedDocuments') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('queryJob.warehouseNo')+'：'">
          <div style="display: flex;">
            <el-input v-model="form.warehouseNo" no="4" type="textarea" :rows="5" size="min" />
            <div style="margin-left: 5px">
              <el-button no="5" type="primary" :disabled="btnGenerateEnable" @click="generateHandler">{{ $t('queryJob.Generate') }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EstimatedWarehousingTime')+'：'" class="custom">
          <cargo-date-time-field-input v-model="form.estimatedDateOfWarehousinge" style="margin-left: -10px" />
        </el-form-item>
        <el-form-item :label="$t('queryJob.OtherInstructions')">
          <div style="display: flex;">
            <el-input v-model="form.otherWarehouseNotes" no="6" type="textarea" :rows="5" size="min" />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="">
      <el-button no="7" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="8" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import { validateMBL, manualGenerateWarehouseNo } from '@/api/AirExport/airExportJob'
import $store from '@/store'
import cargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import { AirExportJob } from '@/class/model/booking/AirExportJob'

export default {
  name: 'WarehouseDialog',
  components: { cargoDateTimeFieldInput },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      form: {
        ownWarehouse: false,
        takePhotos: false,
        documentsAttached: false,
        warehouseNo: '',
        estimatedDateOfWarehousinge: null,
        otherWarehouseNotes: ''
      }
    }
  },
  computed: {
    btnGenerateEnable() {
      return this.job && !this.job.uuid
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      this.init()
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },

  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      if (this.job) {
        this.form.ownWarehouse = this.job.ownWarehouse
        this.form.takePhotos = this.job.takePhotos
        this.form.documentsAttached = this.job.documentsAttached
        this.form.warehouseNo = this.job.warehouseNo
        this.form.estimatedDateOfWarehousinge = this.job.estimatedDateOfWarehousinge
        this.form.otherWarehouseNotes = this.job.otherWarehouseNotes
      }
    },
    // 生成订舱编号
    generateHandler() {
      if (this.job) {
        const newJob = new AirExportJob(this.job)
        manualGenerateWarehouseNo(newJob.getData()).then(res => {
          if (res.data) {
            this.form.warehouseNo = res.data.warehouseNo
          } else {
            this.$message.warning('生成失败！')
          }
        })
      }
    },
    async enterHandler() {
      if (this.validate()) {
        const needConfirmeDuplicateWarehouseNo = cache.config.get('needConfirmeDuplicateWarehouseNo')
        if (Number(needConfirmeDuplicateWarehouseNo) === 1) {
          const fields = {}
          if (this.warehouseNo && this.warehouseNo.trim()) {
            fields.warehouseNo = this.job.warehouseNo
            const body = {
              branchId: $store.getters.currentOfficeId,
              jobKey: this.job.uuid,
              fieldMap: fields
            }
            await validateMBL(body).then(async res => {
              if (res.data && res.data['field'] && res.data['field'] === 'warehouseNo') {
                this.$confirm(this.$t('Payment.warehouseNo') + this.job.warehouseNo + this.$t('queryJob.AlreadyExists') + '\\n' + this.$t('queryJob.Save'), this.$t('common.tips.prompt'), {
                  confirmButtonText: this.$t('common.btn.ok'),
                  cancelButtonText: this.$t('common.btn.cancel'),
                  type: 'warning'
                }).then(() => {
                  this.saveResultHandler()
                }).catch(() => {
                })
              } else {
                this.saveResultHandler()
              }
            })
          } else {
            this.saveResultHandler()
          }
        } else {
          this.saveResultHandler()
        }
      }
    },
    saveResultHandler() {
      this.$emit('warehouseCommitCallback', this.form)
    },
    cancelHandler() {
      this.innerVisible = false
    },
    validate() {
      if (this.form.ownWarehouse) {
        if (!this.form.warehouseNo || !this.form.warehouseNo.trim()) {
          this.$message.warning(this.$t('Message.PleaseEnterTheWarehousingNumber'))
          return false
        } else if (!this.form.estimatedDateOfWarehousinge) {
          this.$message.warning(this.$t('queryJob.PleaseTheEstimatedWarehousingTime'))
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>

</style>
